module.exports = __webpack_public_path__ + "img/H5.0baa0abf.png";